import { msalInstance } from '@/app/msal';

export const signOut = async (): Promise<void> => {
  await msalInstance.logoutRedirect({
    account: msalInstance.getActiveAccount() ?? undefined,
    postLogoutRedirectUri: globalThis.location.origin,
  });
};
